module.exports = __webpack_public_path__ + "files/f0cf8cc5bfde5e13058874a9a08df5a3.svg";